/**
 * Category group constants
 * Define the valid top-level category groups in the system
 */

export const CATEGORY_GROUPS = {
    BUSINESS_TRAVEL: "Business travel",
    GENERAL: "General",
    MEALS: "Meals",
} as const;

export type CategoryGroup = (typeof CATEGORY_GROUPS)[keyof typeof CATEGORY_GROUPS];

/**
 * Default category group when creating a new category
 */
export const DEFAULT_CATEGORY_GROUP = CATEGORY_GROUPS.GENERAL;

/**
 * All available category group options for dropdowns
 */
export const CATEGORY_GROUP_OPTIONS = [CATEGORY_GROUPS.BUSINESS_TRAVEL, CATEGORY_GROUPS.GENERAL, CATEGORY_GROUPS.MEALS] as const;

export function normalizeCategoryGroup(categoryGroup: string | null | undefined): string {
    if (!categoryGroup) {
        return DEFAULT_CATEGORY_GROUP;
    }

    const normalized = categoryGroup.trim();
    const lowerNormalized = normalized.toLowerCase();

    // Check if input matches any canonical group (case-insensitive)
    for (const group of CATEGORY_GROUP_OPTIONS) {
        if (group.toLowerCase() === lowerNormalized) {
            return group;
        }
    }

    return normalized;
}

export function getCategoryGroupOptions(categoryGroup?: string | null) {
    const normalizedCategoryGroup = normalizeCategoryGroup(categoryGroup);
    if (!normalizedCategoryGroup || CATEGORY_GROUP_OPTIONS.includes(normalizedCategoryGroup as (typeof CATEGORY_GROUP_OPTIONS)[number])) {
        return CATEGORY_GROUP_OPTIONS;
    }

    return [normalizedCategoryGroup, ...CATEGORY_GROUP_OPTIONS] as const;
}
